import { render, staticRenderFns } from "./FixedHeader.vue?vue&type=template&id=4336736d&"
import script from "./FixedHeader.vue?vue&type=script&lang=js&"
export * from "./FixedHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports